import { useEffect, useMemo, useState } from 'react';
import Toast from './Toast';
import Loader from './Loader';
import logo from '../img/logo.png'
import farmerIdImage from '../img/identity.png'
import indian_flag from '../img/indian_flag.png';
import bg_mitra_emblem_of_india from '../img/Emblem_of_India.png';
import FarmerCardPDF from '../pdf/AgriStackPDF';
import { pdf } from '@react-pdf/renderer';
import QRCode from 'qrcode';
import { debounce } from 'lodash';



const NewAgriStackPage = () => {



    const [loading, setLoading] = useState(false);
    const [aadharNumber, setAadharNumber] = useState('');
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
    const [errors, setErrors] = useState({});
    const [rechargeAmount, setRechargeAmount] = useState(0);



    const [farmerData, setFarmerData] = useState(null);

    useEffect(() => {
        // fetchWallet();
    }, []);

    const sampelCard = () => {
        const sapleResposne = {
            "userId": 35,
            "nameMr": "शेतकऱ्याचे नाव",
            "nameEn": "Farmers Name in english",
            "dob": "जन्म तारीख",
            "gender": "Male",
            "mhFarmerId": null,
            "centralId": "12341234123",
            "addressMr": "Address -Pincode",
            "addressEn": "Address -Pincode",
            "mobileNumber": "मोबाइल नंबर",
            "aadharNo": "MTIzNDEyMzQxMjM0",
            "createdBy": "navnathadsul99@gmail.com",
            "paymentId": 89,
            "totalArea": 5.5,
            "khataNumbers": {
                "शिवार1": [
                    "खाते क्रमांक"
                ],
                "शिवार2": [
                    "खाते क्रमांक"
                ]
            },
            "landDetails": {
                "शिवार1": [
                    "सर्वे नंबर"
                ],
                "शिवार2": [
                    "सर्वे नंबर"
                ]
            }
        }
        preparePdf({ data: sapleResposne });
    }

   


    useEffect(() => {
        if (aadharNumber && aadharNumber.trim().length > 0) {

            const data = parseFarmerData(aadharNumber);
            setFarmerData(data);
        }
    }, [aadharNumber]);
    const downloadFarmerCard = async () => {

        setLoading(true);
        try {

            //const response =   parseFarmerData(aadharNumber);
            console.log("Parsed Farmer Data: 11", farmerData, new Date().toISOString());
            preparePdf(farmerData);
            setToast({ show: true, message: "Farmer card downloaded successfully!", type: 'success' });
        } catch (error) {
            setToast({ show: true, message: error.response?.data || "Please try again!", type: 'error' });
        } finally {

        }
        // }
    };

   




    function parseFarmerData(response) {
        try {
            const data = JSON.parse(response)?.data;
            console.log("Raw API Response:", data);

            if (!data) {
                console.warn("No 'data' object in API response");
                return null;
            }

            const farmerDetails = data.farmerDetails ?? {};
            const idType = farmerDetails.farmerIdentifierType ?? {};
            const genderType = farmerDetails.farmerGenederType ?? {};
            const extRegistry = farmerDetails.farmerExtendedRegistry ?? {};
            const farmerLandOwnerShips = data.farmerLandOwnerShips ?? [];

            const farmer = {
                nameMr: farmerDetails.farmerNameLocal ?? "",
                nameEn: farmerDetails.farmerNameEn ?? "",
                dob: farmerDetails.farmerDob
                    ? formatDate(farmerDetails.farmerDob)
                    : null,
                gender: genderType.genderDescEng ?? "",
                mobileNumber: farmerDetails.farmerMobileNumber ?? "",
                centralId: farmerDetails.centralId ?? "",
                photograph: extRegistry.ferFarmerPhotograph ?? "",
                aadharNo: farmerDetails.farmerAadhaarBase64 ?? "",
                addressEn: "",
                addressMr: "",
                landDetails: {},
                totalArea: 0,
                khataNumbers: {}
            };

            const landDetails = new Map();
            const khataNumbers = new Map();
            let totalArea = 0;

            for (const land of farmerLandOwnerShips) {
                const plot = land.farmlandPlotRegistryId ?? {};
                const villageInfo = plot.villageLgdMaster ?? {};

                const landId = String(plot.landParcelId ?? "")
                    .replace("/*", "");

                const village = villageInfo.villageName ?? "";
                const villageKey = village.trim();

                const area = Number(land.extentTotalAreaInHectare ?? 0);
                const khataNumber = String(land.khataNumber ?? "");

                totalArea += truncateToTwoDecimalPlaces(area);

                // Group unique land parcel IDs by village
                if (!landDetails.has(villageKey)) {
                    landDetails.set(villageKey, new Set());
                }

                landDetails.get(villageKey).add(landId);

                // Group unique khata numbers by village
                if (!khataNumbers.has(villageKey)) {
                    khataNumbers.set(villageKey, new Set());
                }

                khataNumbers.get(villageKey).add(khataNumber);
            }

            // Convert Map/Set structures into plain objects and arrays
            farmer.landDetails = Object.fromEntries(
                [...landDetails].map(([village, ids]) => [
                    village,
                    [...ids]
                ])
            );

            farmer.khataNumbers = Object.fromEntries(
                [...khataNumbers].map(([village, numbers]) => [
                    village,
                    [...numbers]
                ])
            );

            farmer.totalArea = Number(totalArea.toFixed(2));

            const pinCode = farmerDetails.farmerPinCode ?? 0;

            farmer.addressEn =
                `${idType.identifierTypeDescLl ?? ""}  ` +
                `${farmerDetails.farmerIdentifierNameEn ?? ""}, ` +
                `${farmerDetails.farmerAddressEn ?? ""} - ${pinCode}`;

            farmer.addressMr =
                `${idType.identifierTypeDescLl ?? ""}  ` +
                `${farmerDetails.farmerIdentifierNameLocal ?? ""}, ` +
                `${farmerDetails.farmerAddressLocal ?? ""} - ${pinCode}`;

            return farmer;

        } catch (error) {
            console.error("Failed to parse farmer data", error);
            return null;
        }
    }

    function truncateToTwoDecimalPlaces(value) {
        return Math.trunc(Number(value) * 100) / 100;
    }

    function formatDate(input) {
        if (!input) return "";

        // Preserve date-only values without timezone conversion
        const dateOnlyMatch = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);

        if (dateOnlyMatch) {
            const [, year, month, day] = dateOnlyMatch;
            return `${day}/${month}/${year}`;
        }

        const date = new Date(input);

        if (Number.isNaN(date.getTime())) {
            console.error("Invalid date:", input);
            return "";
        }

        return new Intl.DateTimeFormat("en-GB", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }).format(date);
    }

    const preparePdf = async (response) => {
        try {
            const qrdata = await QRCode.toDataURL(`नाव-${response?.nameMr} | ID-${response?.centralId}`);

            // Create dummy image if photograph is not present
            const dummyImage = 'data:image/svg+xml;base64,' + btoa(`
                <svg width="60" height="80" xmlns="http://www.w3.org/2000/svg">
                    <rect width="60" height="80" fill="#f0f0f0" stroke="#ccc"/>
                    <text x="30" y="35" text-anchor="middle" font-size="10" fill="#666">No</text>
                    <text x="30" y="50" text-anchor="middle" font-size="10" fill="#666">Photo</text>
                </svg>
            `);


            const farmer = {
                ...response,
                photograph: response.photograph ?
                    "data:image/jpeg;base64," + response.photograph :
                    dummyImage
            };

            const fileName = `${farmer?.nameEn?.replaceAll(" ", "_")}-${Date.now()}.pdf`;
            const blob = await pdf(<FarmerCardPDF farmerIdImage={farmerIdImage} emblem_of_india={bg_mitra_emblem_of_india} indian_flag={indian_flag} farmer={farmer} logo={logo} qrImage={qrdata} />).toBlob();

            console.log("PDF Blob created:", blob);
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error)
            setLoading(false);
        } finally {
            setLoading(false);
        }

    }


    const debouncedSetQrValue = useMemo(() => {
        return debounce((value) => {
            generateQR(value); // pass value
        }, 250);
    }, []);


    useEffect(() => {
        debouncedSetQrValue(rechargeAmount);
        return () => debouncedSetQrValue.cancel();
    }, [rechargeAmount]);


    const generateQR = async (amount) => {
        const qrdata = await QRCode.toDataURL(`upi://pay?pa=9adsul-hdfc@ybl&pn=Vakralabs Services&am=${amount}&cu=INR&tn=Recharge`);
       // setUPIqrImage(qrdata);
    };



   
    return (
        <div className="container mt-5">






            <div className="row">
                <div className="col-md-5">

                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Download Farmer Card</h5>
                            <div className="mb-3">
                                <label className="form-label">
                                    Aadhar Number <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={aadharNumber}
                                    onChange={(e) => setAadharNumber(e.target.value)}
                                    placeholder="Enter Aadhar Number"
                                />
                                {errors.aadharNumber && (
                                    <div className="text-danger mt-1">{errors.aadharNumber}</div>
                                )}
                            </div>

                            <button
                                className="btn btn-teal w-100"
                                onClick={downloadFarmerCard}
                            /* disabled={!(userWallet?.active && userWallet?.availableAmount >= userWallet.chargeAmount)} */
                            >
                                Download Card
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="card">
                        {/*    <Checkout userWallet={userWallet} onComplete={fetchWallet} /> */}
                    </div>
                </div>
            </div>



            <Toast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <Loader show={loading} />
        </div >
    );
};

export default NewAgriStackPage;